import React from "react";
import { Link } from "react-router-dom";
import SidebarMenuBlocks from "../../components/adminNavigation/SidebarMenuBlocks";
import Button from "../../components/form/Button";
import { useSelector } from "react-redux";
import logo_image from "../../assets/images/logo.png";
import icon from "../../assets/images/fav.png";

const AdminSideBar = ({ isMenuOpen, setMenuOpen = () => {} }) => {
  const { session } = useSelector((state) => state?.authProvider);

  const adminSidebarMenu = [
    {
      _id: "1",
      menuTitle: "",
      menuData: [
        {
          _id: "1",
          menuLabel: "Dashboard",
          menuLink: "/admin/dashboard",
          menuIcon: "fa-light fa-grid-2",
          menuIconColor: "text-chestnut-rose",
        },
      ],
    },
    {
      // _id: "2",
      // menuTitle: "Application Hub",
      menuData: [
        // {
        //   _id: "1",
        //   menuLabel: "Scholarships",
        //   menuLink: "/admin/scholarships",
        //   menuIcon: "fa-light fa-graduation-cap",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "ScholarshipsApp",
        //   menuLabel: "Scholarship App",
        //   menuLink: "/admin/scholarship-application/list",
        //   menuIcon: "fa-light fa-diploma",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "question",
        //   menuLabel: "Questions",
        //   menuLink: "/admin/questions",
        //   menuIcon: "fa-light fa-comment-question",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "2",
        //   menuLabel: "Eligibility Quiz",
        //   menuLink: "/admin/quiz",
        //   menuIcon: "fa-light fa-puzzle",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "3",
        //   menuLabel: "App. Forms",
        //   menuLink: "/admin/appform",
        //   menuIcon: "fa-light fa-clipboard-list",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "1",
        //   menuLabel: "Communications",
        //   menuLink: "/admin/communications",
        //   menuIcon: "fa-light fa-tower-broadcast",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "Resource",
        //   menuLabel: "Resource",
        //   menuLink: "/admin/resources",
        //   menuIcon: "fa-regular fa-file",
        //   menuIconColor: "text-chestnut-rose",
        // },
      ],
    },

    {
      _id: "4",
      menuTitle: "User Management",
      menuData: [
        {
          _id: "admin",
          menuLabel: "Admins",
          menuLink: "/admins",
          menuIcon: "fa-light fa-users",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "1",
          menuLabel: "Users",
          menuLink: "/admin/users",
          menuIcon: "fa-light fa-users",
          menuIconColor: "text-chestnut-rose",
        },
        // {
        //   _id: "2",
        //   menuLabel: "Access Control",
        //   menuLink: "/admin/accesscontrol",
        //   menuIcon: "fa-light fa-sliders",
        //   menuIconColor: "text-chestnut-rose",
        // },
      ],
    },
    {
      _id: "3",
      menuTitle: "Finance Management",
      menuData: [
        {
          _id: "plans",
          menuLabel: "Plans",
          menuLink: "/admin/plans",
          menuIcon: "fa-light fa-credit-card",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "subscription",
          menuLabel: "Subscriptions",
          menuLink: "/admin/subscription",
          menuIcon: "fa-regular fa-receipt",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "transaction",
          menuLabel: "Transactions",
          menuLink: "/admin/transaction",
          menuIcon: "fa-solid fa-money-bill-wave",
          menuIconColor: "text-chestnut-rose",
        },
        //     {
        //       _id: "2",
        //       menuLabel: "Finances",
        //       menuLink: "/admin/finances",
        //       menuIcon: "fa-light fa-sack-dollar",
        //       menuIconColor: "text-chestnut-rose",
        //     },
      ],
    },
    // {
    //   _id: "content",
    //   menuTitle: "Content Management",
    //   menuData: [
    //     {
    //       _id: "collection-template",
    //       menuLabel: "Collection Template",
    //       menuLink: "/admin/collection-template",
    //       menuIcon: "fa-solid fa-th-large",
    //       menuIconColor: "text-chestnut-rose",
    //     },
    //     {
    //       _id: "user-collections",
    //       menuLabel: "User's Collections",
    //       menuLink: "/admin/user-collections",
    //       menuIcon: "fa-solid fa-layer-group",
    //       menuIconColor: "text-chestnut-rose",
    //     },
    //   ],
    // },
    {
      // _id: "apply",
      // menuTitle: "apply",
      menuData: [
        // {
        //   _id: "eligibility",
        //   menuLabel: "Eligibility",
        //   menuLink: "/admin/eligibility",
        //   menuIcon: "fa-light fa-graduation-cap",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "timeline",
        //   menuLabel: "Timeline",
        //   menuLink: "/admin/scholarship-timeline",
        //   menuIcon: "fa-light fa-timeline-arrow",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "news",
        //   menuLabel: "News",
        //   menuLink: "/admin/news",
        //   menuIcon: "fa-light fa-newspaper",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "timeline",
        //   menuLabel: "Timeline",
        //   // menuLink: "/admin/timeline",
        //   menuLink: "/admin/timeline",
        //   menuIcon: "fa-light fa-timeline-arrow",
        //   menuIconColor: "text-chestnut-rose",
        // },
      ],
    },
    {
      _id: "e-commerce",
      menuTitle: "E-commerce Management",
      menuData: [
        {
          _id: "order",
          menuLabel: "Orders",
          menuLink: "/admin/orders",
          menuIcon: "fa-light fa-box",
          menuIconColor: "text-chestnut-rose",
        },
      ],
    },
    {
      _id: "5",
      menuTitle: "CMS Management",
      menuData: [
        {
          _id: "faq",
          menuLabel: "FAQs",
          menuLink: "/admin/faq",
          menuIcon: "fa-light fa-square-question",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "hiw",
          menuLabel: "How It Works",
          menuLink: "/admin/how-it-works",
          menuIcon: "fa-solid fa-lightbulb",
          menuIconColor: "text-chestnut-rose",
        },
        // {
        //   _id: "4",
        //   menuLabel: "Pages",
        //   menuLink: "/admin/pages",
        //   menuIcon: "fa-light fa-presentation-screen",
        //   menuIconColor: "text-chestnut-rose",
        // },

        {
          _id: "4",
          menuLabel: "Pages",
          menuLink: "/admin/pages",
          menuIcon: "fa-light fa-presentation-screen",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "5",
          menuLabel: "Footer Pages",
          menuLink: "/admin/footer-pages",
          menuIcon: "fa-light fa-presentation-screen",
          menuIconColor: "text-chestnut-rose",
        },

        // {
        //   _id: "banners",
        //   menuLabel: "Banners",
        //   menuLink: "/admin/banners",
        //   menuIcon: "fa-light fa-photo-film",
        //   menuIconColor: "text-chestnut-rose",
        // },

        // {
        //   _id: "Publications",
        //   menuLabel: "Publications",
        //   menuLink: "/admin/publications",
        //   menuIcon: "fa-light fa-books",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "PublicationCategories",
        //   menuLabel: "Publication Categories",
        //   menuLink: "/admin/publication/categories",
        //   menuIcon: "fa-light fa-icons",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "1",
        //   menuLabel: "Blogs",
        //   menuLink: "/admin/blogs",
        //   menuIcon: "fa-light fa-blog",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "2",
        //   menuLabel: "Blogs Categories",
        //   menuLink: "/admin/blog/categories",
        //   menuIcon: "fa-light fa-icons",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "5",
        //   menuLabel: "Projects",
        //   menuLink: "/admin/projects",
        //   menuIcon: "fa-light fa-boxes-stacked",
        //   menuIconColor: "text-chestnut-rose",
        // },

        // {
        //   _id: "3",
        //   menuLabel: "Events",
        //   menuLink: "/admin/events",
        //   menuIcon: "fa-light fa-calendar-days",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "partners",
        //   menuLabel: "Partners",
        //   menuLink: "/admin/partners",
        //   menuIcon: "fa-light fa-handshake",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "5",
        //   menuLabel: "Testimonials",
        //   menuLink: "/admin/testimonials",
        //   menuIcon: "fa-light fa-comment-smile",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "Sections",
        //   menuLabel: "Sections",
        //   menuLink: "/admin/sections",
        //   menuIcon: "fa-light fa-blog",
        //   menuIconColor: "text-chestnut-rose",
        // },
        {
          _id: "6",
          menuLabel: "Email Templates",
          menuLink: "/admin/email-template",
          menuIcon: "fa-regular fa-envelope-open",
          menuIconColor: "text-chestnut-rose",
        },

        {
          _id: "7",
          menuLabel: "Site Settings",
          menuLink: "/admin/site-settings",
          menuIcon: "fa-light fa-gear",
          menuIconColor: "text-chestnut-rose",
        },
      ],
    },
    // {
    //   _id: "6",
    //   menuTitle: "",
    //   menuData: [
    //     {
    //       _id: "1",
    //       menuLabel: "Settings",
    //       menuLink: "/admin/settings",
    //       menuIcon: "fa-light fa-gear",
    //       menuIconColor: "text-chestnut-rose",
    //     },
    //   ],
    // },
  ];

  const userSidebarMenu = [
    {
      _id: "1",
      menuTitle: "",
      menuData: [
        // {
        //   _id: "home",
        //   menuLabel: "Go to Website",
        //   menuLink: "/",
        //   blank: true,
        //   menuIcon: "fa-regular fa-house",
        //   menuIconColor: "text-chestnut-rose",
        // },
        {
          _id: "user-dashboard",
          menuLabel: "Dashboard",
          menuLink: "/dashboard",
          menuIcon: "fa-solid fa-table-cells",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "user-plans",
          menuLabel: "Plans",
          menuLink: "/user/plans",
          menuIcon: "fa-light fa-credit-card",
          menuIconColor: "text-chestnut-rose",
        },
        // {
        //   _id: "user-fa-solid fa-table-cells",
        //   menuLabel: "Applications",
        //   menuLink: "/user/applications",
        //   menuIcon: "fa-solid fa-table-cells",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "user-Communications",
        //   menuLabel: "Communications",
        //   menuLink: "/user/communications",
        //   menuIcon: "fa-regular fa-comments",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "user-Resources",
        //   menuLabel: "Resources",
        //   menuLink: "/user/resources",
        //   menuIcon: "fa-regular fa-file",
        //   menuIconColor: "text-chestnut-rose",
        // },
        // {
        //   _id: "user-Profile Information",
        //   menuLabel: "Profile Information",
        //   menuLink: "/user/profile",
        //   menuIcon: "fa-regular fa-clipboard",
        //   menuIconColor: "text-chestnut-rose",
        // },
      ],
    },
  ];

  const sidebarData =
    session?.user?.role === "user"
      ? userSidebarMenu
      : session?.user?.role === "admin" && adminSidebarMenu;

  return (
    <>
      <div className="relative w-full">
        <div
          className={
            `relative py-4 flex items-center gap-4 transition-all duration-100 z-60 border-slate-700` +
            (isMenuOpen ? "px-3" : "px-3")
          }
        >
          <Link className="h-12  mx-auto" to={"/"} replace>
            <img
              className="w-full h-full object-contain"
              src={!isMenuOpen ? logo_image : icon}
              alt={"Logo"}
            />
          </Link>
        </div>
        <div
          className={
            "relative overflow-auto scroll-smooth scrollbar scrollbar-1 h-full max-h-[calc(100vh-9rem)] transition-all duration-100 divide-y " +
            (isMenuOpen ? " divide-slate-800" : "divide-transparent")
          }
        >
          {session?.status === "authorized" &&
            Array.isArray(sidebarData) &&
            sidebarData?.map((item, index) => {
              if (item) {
                return (
                  <SidebarMenuBlocks
                    key={item._id}
                    menuTitle={item.menuTitle}
                    menuData={item.menuData}
                    isMenuOpen={isMenuOpen}
                    icon={icon}
                  />
                );
              }
              return null;
            })}
        </div>
      </div>
    </>
  );
};

export default AdminSideBar;
